"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@heroui/react";
import { cn } from "@heroui/styles";
import Image from "next/image";
import { Experiences } from "@/components/landing/experiences";
import { WorldMap } from "@/components/world-map";
import { useScopedI18n } from "@/lib/i18n";
import CafeImage from "@/assets/designs/cafe.png";
import ECommerceImage from "@/assets/designs/ecommerce.png";
import TravelImage from "@/assets/designs/travel.png";
const links = {
  github: "https://github.com/itsbrunodev",
  kofi: "https://ko-fi.com/itsbrunodev",
  linkedin: "https://linkedin.com/in/brunolepis"
};
function SocialLink(t0) {
  const $ = _c(4);
  const {
    name,
    href
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link.Icon />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== href || $[2] !== name) {
    t2 = <Link className="not-prose text-base" href={href} target="_blank">{name}{t1}</Link>;
    $[1] = href;
    $[2] = name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export default function About() {
  const $ = _c(72);
  const t = useScopedI18n("about");
  let t0;
  if ($[0] !== t) {
    t0 = t("title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h1 className="px-4 font-semibold text-2xl">{t0}</h1>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = new Date().getFullYear();
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("description", {
      years: t2 - 2020
    });
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p>{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("skills.description");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <p>{t5}</p>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("education.description");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <p>{t7}</p>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("languages.description");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("hobbies.description");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <p>{t9} {t10}</p>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t4 || $[26] !== t6 || $[27] !== t8) {
    t12 = <div className="px-4">{t4}{t6}{t8}{t11}</div>;
    $[24] = t11;
    $[25] = t4;
    $[26] = t6;
    $[27] = t8;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="not-prose mb-4 grid grid-cols-3">{[CafeImage, TravelImage, ECommerceImage].map(_temp)}</div>;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t) {
    t14 = t("contact.title");
    $[30] = t;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14) {
    t15 = <h2>{t14}</h2>;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  let t17;
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SocialLink name="GitHub" href={links.github} key="github" />;
    t17 = <SocialLink name="Kofi" href={links.kofi} key="kofi" />;
    t18 = <SocialLink name="LinkedIn" href={links.linkedin} key="linkedin" />;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
  } else {
    t16 = $[34];
    t17 = $[35];
    t18 = $[36];
  }
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Link className="not-prose text-base" href="mailto:contact@itsbruno.dev" target="_blank" key="email">contact@itsbruno.dev<Link.Icon /></Link>;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t) {
    t20 = t("contact.description", {
      github: t16,
      kofi: t17,
      linkedin: t18,
      email: t19
    });
    $[38] = t;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t20) {
    t21 = <p>{t20}</p>;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t15 || $[43] !== t21) {
    t22 = <div className="px-4">{t15}{t21}</div>;
    $[42] = t15;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t) {
    t23 = t("experiences.title");
    $[45] = t;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t23) {
    t24 = <h2 className="px-4">{t23}</h2>;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Experiences className="not-prose" />;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== t24) {
    t26 = <div>{t24}{t25}</div>;
    $[50] = t24;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== t) {
    t27 = t("traveling.title");
    $[52] = t;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== t27) {
    t28 = <h2>{t27}</h2>;
    $[54] = t27;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== t) {
    t29 = t("traveling.description");
    $[56] = t;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== t29) {
    t30 = <p>{t29}</p>;
    $[58] = t29;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <WorldMap />;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t28 || $[62] !== t30) {
    t32 = <div className="px-4">{t28}{t30}{t31}</div>;
    $[61] = t28;
    $[62] = t30;
    $[63] = t32;
  } else {
    t32 = $[63];
  }
  let t33;
  if ($[64] !== t12 || $[65] !== t22 || $[66] !== t26 || $[67] !== t32) {
    t33 = <div className="typography">{t12}{t13}{t22}{t26}{t32}</div>;
    $[64] = t12;
    $[65] = t22;
    $[66] = t26;
    $[67] = t32;
    $[68] = t33;
  } else {
    t33 = $[68];
  }
  let t34;
  if ($[69] !== t1 || $[70] !== t33) {
    t34 = <div>{t1}{t33}</div>;
    $[69] = t1;
    $[70] = t33;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  return t34;
}
function _temp(image, index) {
  return <Image className={cn("rounded-large border shadow-xs", index % 2 === 0 ? "rotate-1" : "-rotate-1")} src={image} alt={`Design ${index + 1}`} draggable={false} key={index} />;
}